module.exports = __webpack_public_path__ + "static/media/family-looking-at-tablet_1.e64324d2.jpeg";